import config from '../../config';

let size = 1022;
let xSpeed = 2;
let ySpeed = 0;
let leftEdge = config.CENTER_X - size;
let rightEdge = config.CENTER_X + size;

class Bile {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;
    this.topFg = [];
    this.topBg = [];
    this.bottom = [];
    let sprite;
    this.rising = false;
    this.transitionActive = false;
    this.receding = false;

    ySpeed = 0;
    this.speed = ySpeed;
    this.scrollY = g.levelManager.height;
    // center bg
    sprite = g.add.sprite(config.CENTER_X, this.scrollY, 'bile-top');
    sprite.setScale(0.5);
    sprite.setOrigin(0.5, 0);
    this.topBg.push(sprite);
    // left bg
    sprite = g.add.sprite(config.CENTER_X - size, this.scrollY, 'bile-top');
    sprite.setScale(0.5);
    sprite.setOrigin(0.5, 0);
    this.topBg.push(sprite);
    // center fg
    sprite = g.add.sprite(config.CENTER_X, this.scrollY, 'bile-top');
    sprite.setScale(0.5);
    sprite.setOrigin(0.5, 0);
    this.topFg.push(sprite);
    // right fg
    sprite = g.add.sprite(config.CENTER_X + size, this.scrollY, 'bile-top');
    sprite.setScale(0.5);
    sprite.setOrigin(0.5, 0);
    this.topFg.push(sprite);
    // bottom fill
    sprite = g.add.sprite(config.CENTER_X, this.scrollY + size, 'bile-fill');
    sprite.setScale(0.5);
    sprite.setOrigin(0.5, 0);
    this.bottom.push(sprite);
    sprite = g.add.sprite(config.CENTER_X, this.scrollY + size, 'bile-fill');
    sprite.setScale(0.5);
    sprite.setOrigin(0.5, 0);
    this.bottom.push(sprite);
  }
  update () {
    let g = this.g;

    if ((!this.rising && !this.receding) || this.transitionActive) { return; }

    this.updateScrollPosition();

    this.scrollY -= ySpeed;
    if (this.scrollY <= g.cameras.main.scrollY) {
      this.scrollY = g.cameras.main.scrollY;
    }
    if (this.receding && this.scrollY > g.levelManager.height) {
      // console.log('stop receing');
      this.receding = false;
      this.scrollY = g.levelManager.height;
    }
  }
  updateScrollPosition () {
    // move the topBg right
    _.each(this.topBg, (sprite) => {
      let x = sprite.x + xSpeed >= rightEdge ? leftEdge : sprite.x + xSpeed;
      sprite.setPosition(x, this.scrollY);
    });
    // move the topFg left
    _.each(this.topFg, (sprite) => {
      let x = sprite.x - xSpeed <= leftEdge ? rightEdge : sprite.x - xSpeed;
      sprite.setPosition(x, this.scrollY);
    });
    _.each(this.bottom, (sprite) => {
      sprite.setY(this.scrollY + size);
    });
  }
  start () {
    let g = this.g;
    if (this.rising) { return; }
    this.rising = true;
    this.receding = false;
    g.time.delayedCall(config.BILE_START_DELAY, () => {
      ySpeed = config.BILE_START_SPEED + (config.BILE_SPEED_INCRAMNET * g.levelManager.levelsCleared);
      ySpeed = ySpeed < config.BILE_MAX_SPEED ? ySpeed : config.BILE_MAX_SPEED;
      this.speed = ySpeed;
      // console.log('Start Bile. Speed:', ySpeed);
    });
  }

  transition () {
    let g = this.g;
    this.transitionActive = true;
    let targets = [];

    _.each(this.topBg, (sprite) => {
      targets.push(sprite);
    });
    _.each(this.topFg, (sprite) => {
      targets.push(sprite);
    });
    _.each(this.bottom, (sprite) => {
      targets.push(sprite);
    });

    g.tweens.add({
      targets: targets,
      y: '+=' + config.HEIGHT,
      duration: config.TRANSITION_DURATION,
      ease: 'Sine.easeOut'
    });
  }
  reset () {
    let g = this.g;
    ySpeed = 0;
    this.speed = ySpeed;
    this.receding = false;
    this.rising = false;
    this.scrollY = g.levelManager.height;
    this.updateScrollPosition();
    _.each(this.topBg, (sprite) => {
      g.children.bringToTop(sprite);
    });
    _.each(this.topFg, (sprite) => {
      g.children.bringToTop(sprite);
    });
    _.each(this.bottom, (sprite) => {
      g.children.bringToTop(sprite);
    });
    g.time.delayedCall(config.BILE_START_DELAY, () => {
      this.transitionActive = false;
    });
  }
  knockDown () {
    let g = this.g;
    // this.scrollY = g.levelManager.height;
    this.scrollY += 512;
  }
  recede () {
    let g = this.g;
    if (this.rising) {
      this.receding = true;
      this.rising = false;
      ySpeed = config.BILE_REVERSE_SPEED;
      this.speed = ySpeed;
    }
  }
  get x () {
    return 0;
  }
  get y () {
    return this.scrollY + 10;
  }
  get width () {
    return config.WIDTH;
  }
  get height () {
    return config.HEIGHT;
  }
}

export default Bile;
